export default {
  props: {
    onclose: {
      type: Function
    },
    hideCloseButton: Boolean,
    bully: {
      type: Boolean,
      default: true
    },
    overflow: {
      type: Boolean,
      default: true
    },
    contents: {
      type: Boolean
    },
    title: String,
    text: String,
    content: String,
    footer: Array,
    fixedWidth: Boolean,
    slotsConfig: Object
  },
  computed: {
    slots() {
      return Object.entries(this.$slots);
    },
    activeSlot() {
      return this.slotsConfig?.activeSlot;
    },
    currentSlot() {
      return this.slotsConfig ? this.slotsConfig[this.activeSlot] : undefined;
    },
    rawSlot() {
      return this.currentSlot?.raw;
    },
    currentHeaderIcon() {
      return this.currentSlot?.headerIcon || this.headerIcon;
    },
    currentTitle() {
      return this.ProcessText(this.currentSlot?.title || this.title);
    },
    currentText() {
      return this.ProcessText(this.currentSlot?.text || this.text);
    },
    currentContent() {
      return this.ProcessText(this.currentSlot?.content || this.content);
    },
    currentFooter() {
      return this.currentSlot?.footer || this.footer;
    },
    computedBully() {
      return !this.hideCloseButton && (this.currentSlot?.bully ?? this.bully);
    },
    computedOnclose() {
      return this.currentSlot?.onclose || this.slotsConfig?.onclose || this.onclose;
    },
    slotsConfig_() {
      return this.slotsConfig ?? {};
    }
  },
  created() {
    if (this.slotsConfig) {
      this.slotsConfig_.RenderSlot = this.RenderSlot;
    }
  },
  methods: {
    ProcessText: function (text) {
      if (typeof text === 'function') return text();
      return text;
    },
    RenderSlot: function (to) {
      if (!this.slotsConfig) return;
      if (typeof to === 'string') {
        return this.slotsConfig_.activeSlot = to;
      }
      const index = this.slots[0].indexOf(this.activeSlot);
      if (index === -1 || to === 1 && index === this.slots[0].length - 1 || to === -1 && index === 0) return;
      this.slotsConfig_.activeSlot = this.slots[0][index + to];
    },
    HandleClick: async function (button) {
      const action = button.click || button.onclick || button.callback;
      if (!action) return;
      button.loading = true;
      await action();
      button.loading = false;
      if (button.afterClick) button.afterClick();
    }
  }
};